export function getLocationOrigin(): string {
    return (window.location.origin) 
            ? `${window.location.origin}/` 
            : `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/`;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/utils/url-helpers.ts